import ContactDataForm from './ContactDataForm';

export default ContactDataForm;